module.exports = __webpack_public_path__ + "images/slobodnadomena-logo-blue-1ab7fb7d86513f5cc1f5475c14effbb3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/slobodnadomena-logo-blue.svg
// module id = 2
// module chunks = 0